import React, { Component } from "react";
import { Container, Row, Col, Carousel } from "react-bootstrap";

export default class Company extends Component {


    render() {
        const { company = [] } = this.props;

        return (
            <section style={{ height: "75vh", background: "#fff" }}>
                <Container className="h-100">
                    <Row className="h-100 d-flex align-items-center">
                        <Col xs={12} lg={6}>
                            <Carousel>
                                {company.image.carousel.map((item, index) => (
                                    <Carousel.Item key={index}>
                                        <img
                                            className="d-block w-100"
                                            src={item.image}
                                            alt={`carousel-${company.name}`}
                                        />
                                    </Carousel.Item>
                                ))}
                            </Carousel>
                        </Col>
                        <Col xs={12} lg={6} className="d-flex align-items-start justify-content-center flex-column pl-0 pl-lg-5">
                            <h2 className="mb-4">{company.name}</h2>
                            <p className="text-justify" style={{ lineHeight: "2" }}>{company.description}</p>
                        </Col>
                    </Row>
                </Container>
            </section>
        );
    }
}